export default __webpack_public_path__ + "static/media/close_x.16fbacfb.svg";